import Left from "@repo/icons/default/Left";
import { createFileRoute } from "@tanstack/react-router";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import {
  PageTitleRoot,
  PageTitleMainContent,
  PageTitleDescription,
} from "@/components/ui/layout/page-title/page-title-root";
import { RescuedAppointmentsFeatureSettingsSection } from "@/components/assist/feature-settings/rescued-appointments-feature-settings-section";

import type { JSX } from "react";

const FeatureSettingsPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Configurações Livance Assist" />
      </HeaderRoot>
      <Page>
        <PageTitleRoot>
          <PageTitleMainContent>
            Configure seu Livance Assist como preferir
          </PageTitleMainContent>
          <PageTitleDescription>
            Gerencie as funcionalidades e automações disponíveis no seu plano.
          </PageTitleDescription>
        </PageTitleRoot>

        <div className="flex flex-col gap-8 mt-8">
          <RescuedAppointmentsFeatureSettingsSection />
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/feature-settings/")({
  component: FeatureSettingsPage,
  pendingComponent: () => <PendingComponent title="Configurações Livance Assist" />,
});
